<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Form -->
  <app-ios-certificate-generator-form-section id="form" />
  <!-- Info -->
  <app-ios-certificate-generator-info-section />
  <!-- FAQ -->
  <app-ios-certificate-generator-faq-section />
  <!-- CTA -->
  <app-cta-section id="cta" />
</div>
